import React, { useState, useEffect } from "react";
import { Image, FormGroup, Button, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import NoteTooltip from "../NoteTooltip";
import validate from "validate.js";
import { isEmpty } from "lodash";
import { useSelector, useDispatch } from "react-redux";
import { resetUserPassword, hideFeildValidationError } from "actions";

const schema = {
  user_password: {
    presence: { allowEmpty: false, message: "is required" },
  },
  confirm_password: {
    presence: { allowEmpty: false, message: "is required" },
    equality: {
      attribute: "user_password",
      message: "does not match",
    },
  },
};

const PasswordResetForm = () => {
  const dispatch = useDispatch();
  const session = useSelector((state) => state.session);
  console.log("session in password reset form", session);
  const navigate = useNavigate();

  const [formState, setFormState] = useState({
    isValid: false,
    values: {
      user_password: "",
      confirm_password: "",
    },
    touched: {},
    errors: {},
  });

  useEffect(() => {
    const errors = validate(formState.values, schema);
    setFormState((prevState) => ({
      ...prevState,
      isValid: !errors,
      errors: errors || {},
    }));
  }, [formState.values]);

  useEffect(() => {
    if (session.error_type === "validation") {
      const errors = session.error;
      setFormState((prevState) => ({
        ...prevState,
        isValid: errors ? false : true,
        errors: errors || {},
      }));
    }
  }, [session.error_type, session.error]);
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormState((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        [name]: value,
      },
      touched: {
        ...prevState.touched,
        [name]: true,
      },
    }));
  };

  const hasError = (field) =>
    formState.touched[field] && formState.errors[field] ? true : false;

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!isEmpty(session.otp_code)) {
      let data = {
        password: formState.values.user_password,
        password_confirmation: formState.values.confirm_password,
        verification_code: session.otp_code,
        id: session.verify_user.id,
      };
      await dispatch(resetUserPassword(data, navigate));
    }
  };

  return (
    <>
      <div className="premier-logo text-center">
        <Image src="/assets/images/NX-logo.svg" />
      </div>
      <div className="login-form">
        <div className="text-center mb-4">
          <h1 className="font-24 fon-weight-s-bold mb-3">
            Reset your Password
          </h1>
          <p className="font-14 font-weight-normal text-secondary">
            Please enter your email address. You will receive instructions to
            reset your password in your inbox.
          </p>
        </div>
        <Form className="pt-5" onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="user_password">
            <Form.Label className="font-16 font-weight-medium">
              New Password <span className="form-star-span">*</span>{" "}
              <NoteTooltip />
            </Form.Label>
            <Form.Control
              type="password"
              name="user_password"
              placeholder="Enter your password"
              className={`h-48 border-radius-99 ps-4 font-13 font-weight-normal ${
                hasError("user_password") ? "is-invalid" : ""
              }`}
              value={formState.values.user_password}
              onChange={handleChange}
            />
            <Form.Control.Feedback type="invalid">
              {hasError("user_password")
                ? formState.errors.user_password[0]
                : null}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3 pt-2" controlId="confirm_password">
            <Form.Label className="font-16 font-weight-medium">
              Confirm Password <span className="form-star-span">*</span>{" "}
              <NoteTooltip />
            </Form.Label>
            <Form.Control
              type="password"
              name="confirm_password"
              placeholder="Enter confirm password"
              className={`h-48 border-radius-99 ps-4 font-13 font-weight-normal ${
                hasError("confirm_password") ? "is-invalid" : ""
              }`}
              value={formState.values.confirm_password}
              onChange={handleChange}
            />
            <Form.Control.Feedback type="invalid">
              {hasError("confirm_password")
                ? formState.errors.confirm_password[0]
                : null}
            </Form.Control.Feedback>
          </Form.Group>
          <Button
            type="submit"
            className="w-100 continue-btn h-48 border-radius-99 mb-3 border-0 continue-btn"
          >
            Continue
          </Button>
        </Form>
        <div className="pt-4 pb-5">
          <Link to="/login">
            <Button className="w-100 h-48 border-radius-99 mb-3 bg-transparent font-weight-s-bold resend-btn">
              Back to login
            </Button>
          </Link>
        </div>
      </div>
    </>
  );
};

export default PasswordResetForm;
